import React from 'react';
import Icons from '../../../../components/Common/Icons/Icons';
import Link from '../../../../components/Common/UI/Link';
import { getGuidanceSettingsFromStorage } from '../../../../components/Pages/Home/SettingsModal/storage-utils';

const isFinancialIns = sessionStorage.getItem('enrollment-completed');

interface LogoFromSettingsProps {
  size: 'xs' | 'sm' | 'lg';
  defaultSrc?: string;
}

export function LogoFromSettings({ size = 'sm', defaultSrc = '/guidance/logo.png' }: LogoFromSettingsProps) {
  const getSizeStyle = (): React.CSSProperties | undefined => {
    if (size === 'sm') {
      return { maxHeight: '78px', maxWidth: '192px' };
    }
    if (size === 'xs') {
      return { maxHeight: '48px', maxWidth: '192px' };
    }

    // size === 'lg'
    return { maxHeight: '220px' };
  };

  return (
    <img
      src={(getGuidanceSettingsFromStorage()?.logo as string) || defaultSrc}
      // '/guidance/logo.png' // - "/guidance/guidance_lq.png"
      alt="bg-cover"
      title="financial institution"
      className="h-min"
      style={getSizeStyle()}
    />
  );
}

export default function Logo() {
  return isFinancialIns ? (
    <Link to="/guidance" className="flex items-center gap-2 min-h-[38px] h-min m-auto w-max">
      {/* h-[40px] */}
      <LogoFromSettings size="sm" />
    </Link>
  ) : (
    <Link to="/guidance" icon={<Icons.GuidanceLogo2 width={168} height={38} className="logo" />} />
  );
}
